import React from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import TicketCategoryForm from './TicketCategoryForm';

// The settings list of ticket categories
const TicketCategoryList: React.FC = () => {

    // Specify the options of this list
    const query = {
        endpoint: 'get_ticket_category_list',
        defaultParams: { 'deleted': false },
        object: 'ticket_category'
    }
    const objectName = 'ticket.category.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deleted'
    const isDraggable = true
    const isPaginated = false

    // Specify the form and row click behaviour of this list
    const formModal = <TicketCategoryForm />;
    const onRowClick = 'editModal'

    // Specify the columns of this list
    const columns: ListColumnType[] = [
        { width: '2fr', field: 'name', label: 'ticket.category.name_label' },
    ];

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            columns={columns}
            isDraggable={isDraggable}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
        />
    );
};

export default TicketCategoryList;
